import { Box } from "@mui/material";
import React from "react";
import Webcam, { WebcamProps } from "react-webcam";

import { SkeletonIndicator } from "./SkeletonIndicator";

export function AnimatedWebcam(props: Partial<WebcamProps> = {}) {
  return (
    <Box className={props.className}>
      <Box className="relative w-full h-full">
        <Webcam {...props} className="h-full absolute left-0 top-0 z-50" />

        <SkeletonIndicator loading width="100%" height="100%" />
      </Box>
    </Box>
  );
}
